import { useState } from "react";
import { FaqCard } from "../../Components/FaqCard/FaqCard";
import "./HelpAndFaq.css";
import { HelpCard } from "../../Components/HelpCard/HelpCard";

function HelpAndFaq() {
    const [activeTab, setActiveTab] = useState("FAQ");

    const logo = (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="92"
            height="111"
            viewBox="0 0 92 111"
            fill="none"
        >
            <path
                d="M65.4449 25.611L75.117 31.0505L50.6292 46.851V58.7662L91.9986 34.7804V27.3284L45.6862 0L0 27.9583V41.6158L45.9926 14.2874L54.946 19.3945L0 53.0676V66.5369L65.4449 25.611Z"
                fill="#00151F"
            />
            <path
                d="M15.0243 80.8149L41.3708 63.7193L41.3708 51.8042L0.00140662 78.3801L0.00140597 85.8322L46.3138 110.57L92 82.612L92 68.9545L92 47.9188L82.8886 53.2288L82.8886 73.8212L46.0074 96.2829L15.0243 80.8149Z"
                fill="#50A854"
            />
        </svg>
    );

    return (<div className="help-and-faq content-wrapper">
        <div className="content-container">
            <div className="help-and-faq-mobile-header" aria-hidden="true">
                <div className="help-and-faq-mobile-header-logo">{logo}</div>
                <h1 className="help-and-faq-mobile-title">
                    {activeTab === "FAQ" ? <><span>Frequently</span><span>Asked</span><span>Questions</span></> : <span>Help</span>}
                </h1>
                <div className="content-divider-line"></div>
            </div>
            <div className="content-left-section">
                <h1 className="content-main-heading">{activeTab === "FAQ" ? <><span>Frequently</span>
                    <span>Asked</span>
                    <span>Questions</span></> : <span>Help</span>}</h1>
                <div className="content-divider-line"></div>
            </div>
            <div className="content-right-section">
                <div className="content-right-header">
                    <div className="content-tabs">
                        <button type="button" className={`content-tab ${activeTab === "HELP" ? "active" : ""}`} onClick={() => setActiveTab("HELP")}>HELP</button>
                        <span className="content-tab-separator" />
                        <button type="button" className={`content-tab ${activeTab === "FAQ" ? "active" : ""}`} onClick={() => setActiveTab("FAQ")}>FAQ</button>
                    </div>
                    <div className="content-logo">{logo}</div>
                </div>
                <div className="content-body">
                    {activeTab === "HELP" ? (
                        <div className="help-content-panel"><HelpCard /></div>
                    ) : (<div className="faq-content-panel"><FaqCard /></div>)}
                </div>
            </div>
        </div>
    </div>
    );
}

export default HelpAndFaq